import { jsx as _jsx } from "react/jsx-runtime";
import { Box, mode, useColorMode } from '@abb/uikit';
import React from 'react';
export const Main = (param)=>{
    let { children, boxProps } = param;
    const { colorMode } = useColorMode();
    return /*#__PURE__*/ _jsx(Box, {
        as: "main",
        flex: "1 1 0%",
        backgroundColor: mode('#F0F0F0', '#0A0B0D')({
            colorMode
        }),
        ...boxProps,
        children: children
    });
};
